import React from 'react';
import Image from '../../../components/AppImage';

const ProfessionalBio = () => {
  const bioData = {
    name: "Bello Fawas",
    title: "Senior Full-Stack Developer",
    location: "Lagos, NG",
    experience: "8+ years",
    profileImage: "https://images.unsplash.com/photo-1763312925186-d945a061d3f2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8MXx8fGVufDB8fHx8fA%3D%3D",
    
    bio: `Passionate full-stack developer with over 8 years of experience building scalable web applications and leading development teams. I specialize in React, Node.js, Python, cloud architecture, Photography, Software Engineering, graphic designer and Day Trading. 

My journey began with a Computer Science degree from Federal School Of Ibadan, where I discovered my love for creating elegant solutions to complex problems. Since then, I've worked with companies ranging from early-stage startups to established tech giants, always focusing on writing clean, maintainable code and mentoring junior developers.I believe in continuous learning and staying current with emerging technologies. When I'm not coding, you'll find me contributing to open-source projects, writing technical articles, or exploring the latest developments in AI and machine learning.`,
    highlights: [
      "Led development teams of 5-12 engineers",
      "Architected systems serving 1M+ daily users",
      "Contributed to some open-source projects",
      "Mentored 10+ junior developers"
    ]
  };

  return (
    <section className="bg-surface py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Professional Photo */}
          <div className="lg:order-2">
            <div className="relative">
              <div className="aspect-square max-w-md mx-auto overflow-hidden rounded-2xl shadow-strong">
                <Image
                  src={bioData?.profileImage}
                  alt={`${bioData?.name} - Professional Photo`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-primary text-primary-foreground px-6 py-3 rounded-xl shadow-moderate">
                <span className="font-semibold">{bioData?.experience}</span>
              </div>
            </div>
          </div>

          {/* Bio Content */}
          <div className="lg:order-1">
            <div className="mb-8">
              <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
                {bioData?.name}
              </h1>
              <h2 className="text-xl lg:text-2xl text-primary font-semibold mb-2">
                {bioData?.title}
              </h2>
              <p className="text-muted-foreground flex items-center">
                <span className="w-2 h-2 bg-success rounded-full mr-2"></span>
                {bioData?.location}
              </p>
            </div>

            <div className="prose prose-lg max-w-none mb-8">
              {bioData?.bio?.split('\n\n')?.map((paragraph, index) => (
                <p key={index} className="text-muted-foreground leading-relaxed mb-4">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Highlights */}
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-foreground mb-4">
                Key Achievements
              </h3>
              {bioData?.highlights?.map((highlight, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-accent rounded-full flex-shrink-0"></div>
                  <span className="text-muted-foreground">{highlight}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalBio;
